import { getSubscriptionApiClient } from "./../../shared/apis/sidekick/api-factories";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GET_SUBSCRIPTION_STATUS_QUERY_KEY } from "./useGetSubscription";
import { apiResponseErrorHandler } from "@shared/apis/sidekick/api-error-handler";
import { toast } from "@shared/services/toast";
import { appLogger } from "@shared/services/app-logger";

type Props = {
  onSuccess?: () => void;
};

export const useCancelSubscription = (props?: Props) => {
  const { onSuccess } = props || {};
  const api = getSubscriptionApiClient();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async () => {
      const response = await api.subscriptionControllerCancelMySubscription();
      queryClient.invalidateQueries({
        queryKey: [GET_SUBSCRIPTION_STATUS_QUERY_KEY],
      });
      toast.warn("Your subscription has been cancelled.");
      onSuccess?.();
      return response;
    },
    onError: async (error: Error) => {
      const apiError = await apiResponseErrorHandler(error);
      if (apiError.status >= 400 && apiError.status < 500) {
        toast.error(apiError.errors[0]);
        return;
      }
      toast.error(
        "Failed to cancel your subscription. If the issue persists, please contact support."
      );
      appLogger.error(`Failed to cancel subscription`, { error });
    },
  });

  return mutation;
};
